// Shared on_load ts file for all sites

import * as React from 'react'
import ReactDOM from 'react-dom/client'
import EventEmitter from 'emittery'
//import Notifications, { notify } from '~/components/Notifications' //should trigger a buils/js/site_name.css file to be created
import TooltipContainer from '~/components/TooltipContainer'
import { User } from './types/user'
import { Empty } from './types/utility'

let components = {
  //Notifications,
  TooltipContainer,
}

let utils = {
  // notify
}

// all declare globals in repo merge, so LEAVE 'window.app' to be site-neutral!
// and moving towards 'window.my_app' for specific types for different apps
declare global {
  interface Window {
    app: {
      views: {}
      config_info: {
        csrf_token?: string | Empty
      }
      testing: {}
      EventEmitter: EventEmitter
      components: typeof components
      utils: typeof utils
      React: typeof React
      ReactDOM: typeof ReactDOM
      current_user?: User
      config?: { [key: string]: string | number | boolean }
      constants?: { [key: string]: string | number | boolean }
    }
  }
}

class OnLoad {
  run() {
    this.initWindowGlobalContainers()
    this.runOnDOM()
    this.runOnLoad()
  }

  // <script> code on pages should run in window.addEventListener('load') in order to come after this
  runOnDOM() {
    document.addEventListener('DOMContentLoaded', () => {
      this.setAuthenticityTokenFromTag()
    })
  }

  runOnLoad() {
    window.addEventListener('load', () => {
    })
  }

  setAuthenticityTokenFromTag() {
    const csrf_token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    window.app.config_info.csrf_token = csrf_token
  }

  initWindowGlobalContainers() {
    window.app = {
      ...(window.app || {}), // may be defined elsewhere, like in _global_javascript
      ...{
        views: {},
        config_info: {},
        testing: {},
        components: components,
        utils: utils,
        React: React,
        ReactDOM: ReactDOM,
        EventEmitter: new EventEmitter,
      }
    }
  }
}

export default new OnLoad
